import img1a from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/1a.webp';
import img1b from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/1b.webp';
import img1c from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/1c.webp';
import img1d from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/1d.webp';
import img1e from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/1e.webp';
import img1f from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/1f.webp';
import img1h from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/1h.webp';
import img1i from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/1i.webp';

import img2a from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/2a.webp';

import img3a from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3a.webp';
import img3b from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3b.webp';
import img3c from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3c.webp';
import img3d from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3d.webp';
import img3e from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3e.webp';
import img3f from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3f.webp';
import img3g from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3g.webp';
import img3h from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3h.webp';
import img3i from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3i.webp';
import img3j from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3j.webp';
import img3k from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3k.webp';
import img3l from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3l.webp';
import img3m from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3m.webp';
import img3n from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3n.webp';
import img3p from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3p.webp';
import img3q from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3q.webp';
import img3s from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3s.webp';
import img3t from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3t.webp';
import img3u from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3u.webp';
import img3v from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/3v.webp';

import img4a from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/4a.webp';
import img4b from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/4b.webp';
import img4c from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/4c.webp';
import img4d from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/4d.webp';
import img4e from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/4e.webp';
import img4f from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/4f.webp';
import img4g from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/4g.webp';

import img5b from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/5b.webp';
import img5d from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/5d.webp';
import img5e from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/5e.webp';
import img5h from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/5h.webp';
import img5j from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/5j.webp';
import img5l from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/5l.webp';
import img5m from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/5m.webp';

import img6a from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/6a.webp';
import img6b from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/6b.webp';

import img7b from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/7b.webp';
import img7c from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/7c.webp';

import img8a from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/8a.webp';
import img8c from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/8c.webp';
import img8d from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/8d.webp';

import img9c from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/9c.webp';
import img9d from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/9d.webp';
import img9f from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/9f.webp';
import img9g from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/9g.webp';
import img9h from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/9h.webp';
import img9i from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/9i.webp';
import img9j from '../../../images/knbf-skjema/seilbat-ikke-beregnet-for-overnatting/9j.webp';


const seilbatIkkeBeregnetForOvernatting = {
	title: 'Seilbåt ikke beregnet for overnatting',
	logo: 'knbf',
	formDescription: 'Mindre seilbåt, ikke beregnet for overnatting',
	tableQuestions: [
		{header: '1. Er båten tett og fri for vann'},
		{
			text: 'A. På land – skrogets utside – seilbåt',
			legendIcon: 'y',
			modalContent: <p>Kontroller at skroget er fritt for alvorlige skader. På båter med kort kjøl er skroget nærmest foran og akter for kjølen sårbart for skader ved grunnstøting.<img src={img1a}/></p>
		},
		{
			text: 'B. På land – skjøten mellom skrog og kjøl – ballast',
			legendIcon: 'y',
			modalContent: <p>Kan se ujevn ut. Er vanligvis mest et estetisk problem.<img src={img1b}/></p>
		},{
			text: 'C. På land – bunnplugg/lenseplugg (dersom slike finnes)',
			legendIcon: 'y',
			modalContent: <p>Kontroller at den sitter godt fast før sjøsetting. Bunnpluggen kan være slitt eller sprukket. Noen har en pakning som bør sjekkes årlig. Byttes ved behov.<img src={img1c}/></p>
		},{
			text: 'D. På land – kontroller at gjennomføringer i skroget er tette (dersom slike finnes)',
			legendIcon: 'y',
			modalContent: <p>Skroggjennomføringer med tilkoblinger for ventiler (= kraner), slanger og selvlens.
				<br/>
				<b>Utvendig</b>: Skrap bort bunnstoff og begroing, og kontroller at det ikke er tegn til korrosjon, sprekker, rust eller gliper mellom flensen på gjennomføringen og skroget. Hvis ventilene har vært stengt gjennom vinteren, er det risiko for at de har frosset i stykker og sprukket.
				<br/>
				<b>Innvendig</b>: Kontroller at gjennomføringen sitter godt fast, ikke har tegn til korrosjon eller lekkasje. Sjekk at slangene ikke har sprekker eller slitasje, og at hendelen sitter godt og ikke er rusten. Tynne plastslanger med spiraler er uegnet. I henhold til gjeldende regelverk skal slanger under eller nær vannlinjen være festet til skroggjennomføringen med doble slangeklemmer i rustfritt stål, og disse skal være montert i motsatt retning. Ventilen bør "motioneres", slik at den er lett å åpne og stenge.<img src={img1d}/></p>
		},{
			text: 'E. På land – selvlensende cockpit (dersom slik finnes)',
			legendIcon: 'y',
			modalContent: <p>Fungerer avrenningen? Sitter eventuelle slanger godt fast? På båter der selvlensen munner ut under vannlinjen, skal det alltid være en stengeventil. Er den lett å åpne, og er den tett når den er stengt?<img src={img1e}/></p>
		},{
			text: 'F. På land – lensepumpe(r)',
			legendIcon: 'y',
			modalContent: <p>Kontroller at slangene er hele og i god stand, at det ikke er sprekker i gummimembranen til den manuelle lensepumpen, at sugeslangen har en sil der den suger i kjølsvinet, og at silen ikke er tett. Kontroller at håndtaket til den manuelle lensepumpen er lett tilgjengelig og passer godt i pumpens feste. Sjekk at elektrisk lensepumpe fungerer.<img src={img1f}/></p>
		},{
			text: 'G. I sjøen – senterbordstamme',
			legendIcon: 'y',
			modalContent: <p>Kontroller tettheten og opphenget til senterbordet.</p>
		},{
			text: 'H. I sjøen – kjølboltene',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det ikke lekker ved kjølboltene/senterbordstammen.<img src={img1h}/></p>
		},{
			text: 'I. I sjøen – kontroller at gjennomføringer i skroget er tette (dersom slike finnes)',
			legendIcon: 'm',
			modalContent: <p>Skroggjennomføringer med tilkoblinger for ventiler (= kraner), slanger og selvlens. Kontroller at det ikke er tegn på lekkasje ved skroggjennomføringen, og at det er tørt ved flensmutteren, ventilens gjenger og slangetilkoblingene. Ventilen bør "motioneres" av og til, slik at den er lett å åpne og stenge.<img src={img1i}/></p>
		},{
			text: 'J. I sjøen – løft alle dørkene',
			legendIcon: 'm',
			modalContent: <p>Kontroller at det ikke er vann under dørk-platene eller i kjølsvinet. Sørg for at det er rent og tørt i kjølsvinet/motorrommet for å raskt oppdage lekkasjer.</p>
		},

		{header: '2. Flytesikkerhet'},
		{
			text: 'A. Ved båt med flytetanker',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de er intakte og sitter godt fast.<img src={img2a}/></p>
		},
		{header: '3. Sikkerhetsutstyr'},
		{
			text: 'A. Anker',
			legendIcon: 'y',
			modalContent: <p>Det finnes en rekke forskjellige typer ankere i ulike størrelser og for forskjellige bunnforhold. Tilpass etter båtens størrelse og ankredyp, inkludert margin for uplanlagt nødankring. Kontroller at tauet/kjettingen er i god stand, og at sjaklene er godt strammet og sikret. Hvis du har ankerspill, ha for vane å feste enden på tauet i båten.<img src={img3a}/></p>
		},{
			text: 'B. Reservanker/drivanker',
			legendIcon: 'y',
			modalContent: <p>Det anbefales at det finnes ombord og er lett tilgjengelig.<img src={img3b}/></p>
		},{
			text: 'C. Badestige/redningsstige',
			legendIcon: 'y',
			modalContent: <p>Minst 560 mm under vannlinjen. Kontroller at du faktisk klarer å klatre opp og at du kan felle den ned når du ligger i vannet.<img src={img3c}/></p>
		},{
			text: 'D. Tau for sleping og lignende',
			legendIcon: 'm',
			modalContent: <p>Tilpasses etter båtens størrelse. Kontroller at tauene er lett tilgjengelige og ikke er sammenfiltret.<img src={img3d}/></p>
		},{
			text: 'E. Røykvarsler',
			legendIcon: 'm',
			modalContent: <p>Kontroller og test røykvarsleren og batteriene i henhold til leverandørens instruksjoner.<img src={img3e}/></p>
		},{
			text: 'F. Brannteppe/Brannslukker',
			legendIcon: 'm',
			modalContent: <p>Kontroller at brannteppet er i etui, er helt, og at du vet hvor det er når du trenger det. Kontroller at manometeret står på grønt, at slangen er hel, at forseglingen er intakt, og at datoen for siste kontroll eller utløpsdato er synlig. Vri på den noen ganger og bank lett på siden for å "lytte" så pulveret fritt beveger seg i slukkeren. Har båten litiumbatterier ombord, kreves spesielle brannslukkere. Kontroller kravene fra ditt forsikringsselskap.<img src={img3f}/></p>
		},{
			text: 'G. Båtshake/bøyefanger',
			legendIcon: 'm',
			modalContent: <p>Kontroller at krok og lignende sitter godt fast – ekstra viktig for båtshaker med teleskopfunksjon.<img src={img3g}/></p>
		},{
			text: 'H. CE-merking / den blå plaketten',
			legendIcon: 'y',
			modalContent: <p>Angir blant annet maksimalt antall personer om bord, maksimal last og maksimal motoreffekt.<img src={img3h}/></p>
		},{
			text: 'I. Fendere',
			legendIcon: 'm',
			modalContent: <p>Minst 4 stk anbefales (tilpasset båtens størrelse).<img src={img3i}/></p>
		},{
			text: 'J. Redningsvester eller flyteplagg',
			legendIcon: 'b',
			modalContent: <p>Skal alltid være om bord og brukes av alle om bord. Redningsvester skal være CE-merket. Bruk skrittstropp dersom det finnes. Vedlikehold oppblåsbare modeller i henhold til produsentens anbefalinger.<img src={img3j}/></p>
		},{
			text: 'K. Fortøyningstau',
			legendIcon: 'm',
			modalContent: <p>Minst 4 stk anbefales (tilpasset båtens vekt). Det bør være rykkdempere – kontroller tilstanden på disse og bytt ved behov.<img src={img3k}/></p>
		},{
			text: 'L. Kasteline/redningsline',
			legendIcon: 'm',
			modalContent: <p>Kontroller at den er hel og i god stand. OBS: En flytende line, slik det skal være, brytes lett ned av sollys. Kun den solbeskyttede delen skal stikke ut av kasteposen. Øv på å bruke linen med jevne mellomrom.<img src={img3l}/></p>
		},{
			text: 'M. Kryssholt',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de sitter godt fast.<img src={img3m}/></p>
		},{
			text: 'N. Lanterner',
			legendIcon: 'm',
			modalContent: <p>Kontroller at de fungerer og er riktig montert. Les deg opp på hva som gjelder for din båt hos Sjøfartsdirektoratet. Lanternene må ikke blende rormannen – kontroller dette i mørket. Ekstra lyspære/LED-pære anbefales.<img src={img3n}/></p>
		},{
			text: 'O. Motorromsvifte (for båt med bensindrevet innenbordsmotor)',
			legendIcon: 'b',
			modalContent: <p>Viktig for å ventilere ut bensindamp og redusere eksplosjonsfare. Kontroller at den fungerer. Kjøres i minst 2 minutter før start og alltid ved fylling av drivstoff.</p>
		},{
			text: 'P. Rekkverkstau, stolper, pulpit og gripehåndtak. Rekkverksnett med hensyn til små barn og kjæledyr',
			legendIcon: 'y',
			modalContent: <p>Kontroller festene i dekket, at vaierne er hele og uskadde, samt at åpnbare rekkverkstau kan åpnes som de skal.<img src={img3p}/></p>
		},{
			text: 'Q. Sikker ombord- og ilandstigning – seilbåt',
			legendIcon: 'y',
			modalContent: <p>Viktig med godt halkebeskyttelse og håndtak. Pulpit og stævstige. Gode sko reduserer risikoen for å falle.<img src={img3q}/></p>
		},{
			text: 'R. Reseåre',
			legendIcon: 'b',
			modalContent: <p>Anbefales, og skal være festet med karabinkrok/lina.</p>
		},{
			text: 'S. Reservekanne',
			legendIcon: 'm',
			modalContent: <p>Kontroller at den er plassert på en passende måte, festet godt, fylt med riktig drivstoff, og at den ikke er for gammel. Sjekk også at reservesprutebeholderen i plast ikke har passert "siste bruksår".<img src={img3s}/></p>
		},{
			text: 'T. Signalhorn/fløyte',
			legendIcon: 'm',
			modalContent: <p>Kontroller at det fungerer. Finnes også håndholdte versjoner.<img src={img3t}/></p>
		},{
			text: 'U. Sjøkart',
			legendIcon: 'b',
			modalContent: <p>Kontroller at det er oppdatert for den planlagte ferdselsveien.<img src={img3u}/></p>
		},{
			text: 'V. Stævøye/låsebygel',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de sitter godt fast, er hele og funksjonelle.<img src={img3v}/></p>
		},{
			text: 'W. Bøtter',
			legendIcon: 'm',
			modalContent: <p>med tau, anbefales. Bra for å øse ut vann, slukke brann eller for andre behov og situasjoner som kan oppstå.</p>
		},

		{header: '4. Nødutstyr'},
		{
			text: 'A. Førstehjelpsutstyr/førstehjelpspakke',
			legendIcon: 'm',
			modalContent: <p>I vanntett pose. Kontroller innholdet og siste forbruksdato.<img src={img4a}/></p>
		},{
			text: 'B. Håndstrålkaster/lyskaster',
			legendIcon: 'm',
			modalContent: <p>Kontroller at de fungerer.<img src={img4b}/></p>
		},{
			text: 'C. Kniv/tau/mykt materiale (for å tette)/vevbåndet tape/pluggene i mykt tre',
			legendIcon: 'y',
			modalContent: <p>For reparasjoner osv. Liggeunderlagmateriale er nyttig for å lage plugger. Det er lett å rive av i passende størrelser uten å bruke verktøy. Treplugger i riktig dimensjon kan med fordel festes med tau ved alle gjennomføringer, og vil alltid være lett tilgjengelige i nødsituasjoner. Lett tilgjengelige kniver på strategiske steder som pulpit/pushpit.<img src={img4c}/></p>
		},{
			text: 'D. Mobiltelefon',
			legendIcon: 'b',
			modalContent: <p>Vanntett og helst med GPS. Last ned SOS Alarm 112-appen og legg inn viktige telefonnumre. Viktig å sjekke mobiloperatørens dekning.<img src={img4d}/></p>
		},{
			text: 'E. Nødbluss/håndbluss',
			legendIcon: 'y',
			modalContent: <p>Ved ferdsel i områder med dårlig mobildekning og åpent vann. I dag finnes også LED nød-/håndbluss. Kontroller siste forbruksdato. Utløpte produkter skal returneres til forhandleren.<img src={img4e}/></p>
		},{
			text: 'F. Nødsender',
			legendIcon: 'y',
			modalContent: <p>PLB (Personal Locator Beacon), SPOT (Satellite Personal Tracker), EPIRB (Emergency Position Indicating Radio Beacon). Bra å ha på åpent vann og i områder med dårlig mobildekning. VÆR OPPMERKSOM PÅ at disse må være korrekt registrert for å fungere.<img src={img4f}/></p>
		},{
			text: 'G. VHF',
			legendIcon: 'y',
			modalContent: <p>Bra å ha på ferdsel på åpent vann. Bærbar, vanntett VHF kan være et godt supplement eller en reservantenne til fast installert VHF ved eventuelt mastbrudd. Før hver sesong bør funksjonskontroll gjennomføres ved å sende en prøvesending, og håndteringen bør repeteres.<img src={img4g}/></p>
		},

		{header: '5. Fremdrift'},
		{
			text: 'A. Avgasslange/lyddemper for seilbåt med innenbordsmotor',
			legendIcon: 'y',
			modalContent: <p>Kontroller at ikke vann kan trenge inn bakveien under seiling. Eksosrøret skal gå i en bue opp mot dekket. Den lavere delen av avgasslangen/lyddemperen skal kunne romme det vannet som kan stå i systemet når motoren er slått av.</p>
		},{
			text: 'B. Akseltetning',
			legendIcon: 'y',
			modalContent: <p>For innenbordsmotor med strak aksel. Finnes i forskjellige utførelser og merker. Kontroller tettheten, og serve i henhold til produsentens anbefalinger.<img src={img5b}/></p>
		},{
			text: 'C. Verktøy samt brytepinne og tennplugger i reserve',
			legendIcon: 'y',
			modalContent: <p>Brytepinne er vanligvis kun for mindre utenbordsmotorer.</p>
		},{
			text: 'D. Belg og dekselplate for motor med S-drev',
			legendIcon: 'y',
			modalContent: <p>Kontroller for sprekkdannelser. Bytt i henhold til produsentens anbefalinger.<img src={img5d}/></p>
		},{
			text: 'E. Impeller',
			legendIcon: 'y',
			modalContent: <p>Kontroller før hver sesong og bytt ved behov i henhold til motorprodusentens anbefalinger. Ha med en i reserve ved lengre turer, f.eks. på åpent vann. Øv på å bytte den før du trenger å gjøre det (for innenbordsmotor). Legg reserveimpelleren mørkt i en tett plastpose slik at gummiet ikke tørker ut så raskt.<img src={img5e}/></p>
		},{
			text: 'F. Kjølevann',
			legendIcon: 'b',
			modalContent: <p>Når motoren startes, kontroller alltid at kjølevannet kommer som det skal.</p>
		},{
			text: 'G. Kjølevannsslange',
			legendIcon: 'm',
			modalContent: <p>Med en lavt plassert motor må kjølevannet komme inn via en slange i en bue godt over vannlinjen, med vakuumventil på høyeste punkt. Sjekk for eventuelle sprekkdannelser i kjølevannsslanger.</p>
		},{
			text: 'H. Motor',
			legendIcon: 'y',
			modalContent: <p>Serve motoren i henhold til instruksjonene fra motorleverandøren.<img src={img5h}/></p>
		},{
			text: 'I. Motorfeste - ved utenbordsmotor',
			legendIcon: 'm',
			modalContent: <p>Kontroller motorfestet på akterspeilet.</p>
		},{
			text: 'J. Offeranoder',
			legendIcon: 'y',
			modalContent: <p>Kontroller før hver sesong og bytt ved behov. Kan finnes både på motor og aksel, samt på ror og skrog i metall. Kan også finnes i innenbordsmotorens kjølesystem.<img src={img5j}/></p>
		},{
			text: 'K. Olje',
			legendIcon: 'm',
			modalContent: <p>I motor, tilbakeslag og drev når aktuelt. Kontrolleres ofte.</p>
		},{
			text: 'L. Propell, propellaksel',
			legendIcon: 'y',
			modalContent: <p>På land – Kontroller at det ikke er noe slark, og at det ikke finnes sprekker ved festingen av eventuell støttestag. Kontroller at bolten som propellen er festet med er sikret, og at bladene på foldepropellen er ordentlig sikret.<img src={img5l}/></p>
		},{
			text: 'M. Sjøvannsfiler (motorkjøling)',
			legendIcon: 'm',
			modalContent: <p>Kontroller og rengjør regelmessig, også i løpet av båtsesongen.<img src={img5m}/></p>
		},

		{header: '6. Styresystem'},
		{
			text: 'A. På land - roropphenget',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det ikke er noe bekymringsfullt slark i opphenget, og at alle deler er i god stand. Kontroller roret om høsten og våren, for eksempel for sprekker, frostsprengning og rust.<img src={img6a}/></p>
		},{
			text: 'B. Kompass montert på rattpedestal',
			legendIcon: 'y',
			modalContent: <p>Kontroller når båten ligger stille at kompasset ikke påvirkes når rattet vries eller av elektronisk utstyr.<img src={img6b}/></p>
		},{
			text: 'C. Rorkult',
			legendIcon: 'm',
			modalContent: <p>Gjerne også ha en rorkult i reserve (alltid hvis båten har rattstyring). Teste nødstyringen på land eller i rolige farvann, slik at du vet hvordan den fungerer når den virkelig trengs.</p>
		},{
			text: 'D. Styring med vajrer',
			legendIcon: 'y',
			modalContent: <p>Kontroller at vajrene er i god stand og at de ikke går i for bratte bøyninger.</p>
		},

		{header: '7. Elektrisk anlegg'},
		{
			text: 'A. Avansert anlegg bør kontrolleres av fagperson',
			legendIcon: 'y',
		},{
			text: 'B. Batterier',
			legendIcon: 'y',
			modalContent: <p>Plasseringen bør være adskilt fra drivstofftank og godt festet, samt plassert slik at de ikke blir oversvømt av moderat mengde inntrengende vann. Ingen løse gjenstander som kan kortslutte polene skal være i samme rom. Sjekk for eventuell oksidasjon på polene. Rens og smør inn. Det bør alltid være en lett tilgjengelig hovedbryter slik at batteriene kan kobles fra ved elektriske feil. Har båten litiumbatterier, er det viktig å skaffe god kjennskap til aktuell type og følge produsentens anbefalinger. Litium har mange fordeler, men skiller seg fra blybatterier når det gjelder vedlikehold, lagring, lading, samt ved skader eller brann. Spesiell lader og et BMS (Battery Management System) kreves, samt at generator/motor er tilpasset. Hvis batterisystemet byttes fra blybatterier til litium, skal arbeidet utføres på en fagmessig måte i henhold til relevante regelverk og gjeldende standarder. Feil håndtering eller installasjon kan skade batteriene. Lader for litiumbatterier skal brukes.<img src={img7b}/></p>
		},{
			text: 'C. Elkabler',
			legendIcon: 'y',
			modalContent: <p>Skal være i flertrådet utførelse og dimensjonert i henhold til gjeldende regler for elektrisk kabling i båt.<img src={img7c}/></p>
		},{
			text: 'D. Sikringer i reserve',
			legendIcon: 'y',
		},


		{header: '8. Drivstoff-system'},
		{
			text: 'A. Drivstoffilter',
			legendIcon: 'y',
			modalContent: <p>Bytt drivstoffilter før hver sesong. Ved oppdagelse av belegg, rengjør tanken. Det er lurt å ha et ekstra drivstoffilter i reserve, selv om båten er utstyrt med omkoblingsbart dobbelt drivstoffilter.<img src={img8a}/></p>
		},{
			text: 'B. Drivstoffslanger',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de er av godkjent kvalitet og i god stand, trukket med gummigjennomføringer for å unngå slitasjeskader.</p>
		},{
			text: 'C. Drivstofftank',
			legendIcon: 'y',
			modalContent: <p>Kontroller før hver sesong tanktilkoblinger, pakninger og bytt ved behov, samt rengjør tanken ved behov.<img src={img8c}/></p>
		},{
			text: 'D. Vannutskiller (hvis slik finnes)',
			legendIcon: 'b',
			modalContent: <p>Kontroller at det ikke er lekkasje ved filteret og dets tilkoblinger, samt at de er byttet i samsvar med instruksjonene. Tøm ut eventuelt vann.<img src={img8d}/></p>
		},


		{header: '9. Rigg og seil'},
		{
			text: 'A. Er riggen satt opp på riktig måte',
			legendIcon: 'y',
			modalContent: <p>Det finnes mye informasjon på nettet, for eksempel "RÅD OG TIPS - Seldén".</p>
		},{
			text: 'B. Fall',
			legendIcon: 'y',
			modalContent: <p>Kontroller for slitasje og nedbrytning forårsaket av sollys.</p>
		},{
			text: 'C. Mastfeste, gjennomgang av dekk',
			legendIcon: 'y',
			modalContent: <p>Kontroller at mastfeste er feilfritt. Hvis masten går gjennom dekket, kontrolleres gjennomgangen og at gummiwedge hindrer masten i å bevege seg i hullet. Eventuelle elektriske tilkoblinger kontrolleres.<img src={img9c}/></p>
		},{
			text: 'D. Mast',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det ikke er noen bulker eller skader.<img src={img9d}/></p>
		},{
			text: 'E. Rev-arrangement',
			legendIcon: 'y',
			modalContent: <p>Prøv årlig å reve for øvelsens skyld og for å se at arrangementene fungerer.</p>
		},{
			text: 'F. Forstagprofil og rullesystem',
			legendIcon: 'y',
			modalContent: <p>Rullesystemet kontrolleres slik at profilen kan rotere lett. Profiler kontrolleres for å sikre at de ikke er vridd eller bøyd, og at seilet lett kan heises helt til toppen. En viktig detalj i rullfokksystemet er at man har riktig fallvinkel (min. 10°), det vil si at fallet ledes bort fra forstaget. Dette for å hindre at fallet trer seg, noe som kan få katastrofale konsekvenser. Forstag kan bli vridd på grunn av falltrassel, men det kan også føre til en ødelagt topprofil og et system som ikke lar seg håndtere.<img src={img9f}/></p>
		},{
			text: 'G. Shackel',
			legendIcon: 'y',
			modalContent: <p>Uskadde og sikkert låste.<img src={img9g}/></p>
		},{
			text: 'H. Seil',
			legendIcon: 'y',
			modalContent: <p>Sjekk etter slitasje og eventuell nedbrytning på grunn av UV-lys.<img src={img9h}/></p>
		},{
			text: 'I. Vant og stag',
			legendIcon: 'y',
			modalContent: <p>En vanlig wire består av 19 tråder. Når en tråd (kardel) har bristet, bytter man hele wiren, og helst "hele paret". Det vil si at en brusten kardel på styrbord undervant medfører at også babords undervant byttes, ettersom de normalt har blitt utsatt for like mange lastvekslinger. Ofte går en kardel av ved mynningen av et presset endestykke, og noen ganger separerer den og vises tydelig som en spiral langs wiren. Men noen ganger må man bruke en liten skrutrekker på de ytre kardelene for at bruddet skal oppdages. Vantskruvene skal være sikret. Sjekk saxsprintene og ha med en reserve.<img src={img9i}/></p>
		},{
			text: 'J. Vinsjer og vinsjveiv',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de ikke har glapp eller går tregt. Service skal utføres i henhold til produsentens anbefalinger. Ha en vinsjveiv i reserve.<img src={img9j}/></p>
		},
	]
}

export default seilbatIkkeBeregnetForOvernatting
